import { Component, OnInit, Input, HostListener } from '@angular/core';

declare const $;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('section .home').height(window.innerHeight);
    $('.welcome').css('margin-top', (window.innerHeight * 0.25));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    $('section .home').height(window.innerHeight);
    $('.welcome').css('margin-top', (window.innerHeight * 0.25));
  }
}
